var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:{
    'required-field': _vm.field.isRequired,
},attrs:{"label":_vm.field.label,"label-for":`id_${_vm.field._id}`}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:({
        required: true,
    }),expression:"{\n        required: true,\n    }"}],class:[
            {
                'is-invalid': _vm.errors.has(_vm.field.label),
            },
            'form-control padding-form-control-custom '
        ],attrs:{"options":_vm.formatOptions,"maxItem":1000,"disabled":_vm.loading || _vm.field.disabled,"placeholder":_vm.field.placeholder,"label":_vm.textField,"track-by":_vm.valueField,"data-vv-name":_vm.field.label,"show-no-results":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }